import { useContentFrameLayout } from '@/components/courses/content-frame.context';
import { FlexContainer } from '@/ui/styled-ui';
import { isMobile } from '@/utils/helpers/ui.helper';
import React from 'react';
import styled, { css } from 'styled-components';

const StyledFrame = styled(FlexContainer)<{
  isMobile: boolean;
  framedScroll: boolean;
}>`
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ framedScroll }) =>
    framedScroll ? 'flex-start' : 'center'};
  background-color: var(--beige-main);
  border-radius: var(--default-border-radius);
  border: 1px solid var(--gray-dark);
  position: relative;
  flex: 1;

  ${({ framedScroll }) =>
    framedScroll &&
    css`
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      height: auto;
      margin-top: var(--small-padding);
      margin-bottom: var(--small-padding);
    `}
`;

export type CourseModuleFrameProps = React.ComponentProps<typeof FlexContainer>;

export const CourseModuleFrame: React.FC<CourseModuleFrameProps> = ({
  children,
  ...rest
}) => {
  const { framedScroll } = useContentFrameLayout();

  return (
    <StyledFrame isMobile={isMobile()} framedScroll={framedScroll} {...rest}>
      {children}
    </StyledFrame>
  );
};
